export default __webpack_public_path__ + "assets/images/3a817114503e2be4953569392fd4b4a3.svg";